import EmployeeModel from "./EmployeeModel";

export default class EmployeeScheduledDateModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.scheduledDate = this.converDateOnlyToDate(data.scheduledDate);
			this.scheduledStartTime = data.scheduledStartTime;
			this.scheduledEndTime = data.scheduledEndTime;
			this.notes = data.internalDescription;

			if (data.employee?.id) {
				this.employee = new EmployeeModel(data.employee);
			}
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	employee: EmployeeModel | null = null;
	/** clr type 'DateOnly' */
	scheduledDate = new Date();
	/** clr type 'TimeOnly' */
	scheduledStartTime = this.timeOnlyFormatter();
	/** clr type 'TimeOnly' */
	scheduledEndTime = this.timeOnlyFormatter();
	notes: string | null = null;

	dateOnlyFormatter() : string {
		const date = new Date(); 
		const y = date.getFullYear();
		const m = date.getMonth() + 1;
		const d = date.getDate();

		const month = m < 10 ? `0${m}` : m + '';
		const day = d < 10 ? `0${d}` : d + '';

		return `${y}-${month}-${day}`;
	}

	timeOnlyFormatter() : string {
		const d = new Date(); 
		const h = d.getHours();
		const m = d.getMinutes();
		const s = d.getSeconds();

		const hours = h < 10 ? `0${h}` : h + '';
		const minutes = m < 10 ? `0${m}` : m + '';
		const seconds = s < 10 ? `0${s}` : s + '';

		return `${hours}:${minutes}:${seconds}`;
	}

	converDateOnlyToDate(date: any) {
		if (!date) {
			return new Date();
		}

		if (typeof date === 'object') { 
			return new Date(date);
		}

		if (typeof date === 'string') {
			const dateChunks = date.split('-');
			if (dateChunks?.length != 3) {
				return new Date();
			}
			
			const dateChunksStrict = dateChunks.map((_: any) => _ * 1);
			return new Date(dateChunksStrict[0], dateChunksStrict[1] - 1, dateChunksStrict[2]);
		}

		return new Date();
	}
}